import React from 'react';
// import { Reliant_loader } from '../../../assets/icons/reliant_loader';
import './style.scss';
import { CircularProgress } from '@mui/material';

interface LoaderProps {
  loading: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ loading }) => {
  return loading ? (
    <div className="loader-container page-builder-loader">
      <div className="loader">
        {/* <div className="svg-img"><Reliant_loader /></div> */}
        <>
          <svg width={0} height={0}>
            <defs>
              <linearGradient
                id="my_gradient"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%">
                <stop offset="0%" stopColor="#60a5fa" />
                <stop offset="100%" stopColor="#2563eb" />
              </linearGradient>
            </defs>
          </svg>
          <CircularProgress
            size={80}
            thickness={1}
            sx={{
              'svg circle': { stroke: 'url(#my_gradient)' },
            }}
          />
        </>
      </div>
    </div>
  ) : null;
};
